import {
  AB_TEST_VARIANTS,
  ABTestContent,
  ABTestId,
} from '@src/services/mobility-bonus/shared/utils/abTest/abTestVariants'

export const AB_TEST_ID_PARAM_KEY = 'tid'

const abTestContentMap = new Map<ABTestId, ABTestContent>(
  Object.entries(AB_TEST_VARIANTS) as [ABTestId, ABTestContent][]
)

export const isValidABTestId = (abTestId: unknown): abTestId is ABTestId =>
  abTestContentMap.has(abTestId as ABTestId)

/**
 * AB 테스트 컨텐츠 조회
 */
export const getABTestContent = (abTestId: ABTestId | null) => {
  if (!abTestId) return null

  const content = abTestContentMap.get(abTestId)
  if (!content) {
    return null
  }
  return content
}

/**
 * 랜덤 AB 테스트 아이디 조회 (마지막 3개 그룹만 랜덤으로 조회)
 */
export const getRandomABTestId = () => {
  const availableGroups = Array.from(abTestContentMap.keys())
  const lastThreeGroups = availableGroups.slice(-3)
  const randomIndex = Math.floor(Math.random() * lastThreeGroups.length)
  return lastThreeGroups[randomIndex]
}

/**
 * 랜덤 AB 테스트 컨텐츠 조회
 */
export const getRandomABTestContent = () => {
  const selectedABTestId = getRandomABTestId()

  return {
    content: getABTestContent(selectedABTestId),
    abTestId: selectedABTestId,
  }
}
